import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import Checkbox from './Checkbox.js';

export const CheckEnabler = (props) => {
	const [ enabled, setEnabled ] = useState(props.enabled ?? false);

	const toggle = () => {
		const _enabled = !enabled;
		
		setEnabled(_enabled);
		if(_enabled === true && props.onEnable != undefined) props.onEnable();
		if(_enabled === false && props.onDisable != undefined) props.onDisable();
	};

	const display_on_reverse = props?.display_on_reverse ?? false;

	return (
		<>
			<Checkbox
				name={`toggle_${props.name}`} 
				value={enabled}
				change={toggle}
				label_props={props.label_props}
				disabled={props.disabled}
				_class={props._class}
			>{props.label ?? "Enable"}</Checkbox>

			{((display_on_reverse === false && enabled === true) || (display_on_reverse === true && enabled === false)) && (
				props.children
			)}
		</>
	)
}

export default injectIntl(CheckEnabler);